import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxTheme } from "./components";
import { AuthProvider } from "./contexts/FirebaseAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
import routes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import XcelQMSChatWidget from "./XcelQMSChatWidget";

// ✅ Import React Query Client
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// ✅ Create a QueryClient instance
const queryClient = new QueryClient();

export default function App() {
  const content = useRoutes(routes);

  return (
    <QueryClientProvider client={queryClient}>
      {" "}
      {/* ✅ Wrap your app with QueryClientProvider */}
      <SettingsProvider>
        <AuthProvider>
          <MatxTheme>
            <CssBaseline />
            {content}
            {/* <XcelQMSChatWidget /> */}
            <ToastContainer />
          </MatxTheme>
        </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}
